import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { GRAY_AUTH_COOKIE_NAME } from "./http.config";
import { CookieService } from "ngx-cookie-service";
import { isPlatformBrowser } from "@angular/common";

@Injectable()
export class JwtService {
  constructor(
    private cookieService: CookieService,
    @Inject(GRAY_AUTH_COOKIE_NAME) private cookieName: string,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {
  }

  getToken() {
    return this.cookieService.get(this.cookieName);
  }

  saveToken(token: string): void {
    this.cookieService.set(this.cookieName, token, {path: '/'});
  }

  destroyToken() {
    isPlatformBrowser(this.platformId);
    {
      this.cookieService.delete(this.cookieName, '/');
    }
  }
}
